import { ClientModel } from './ClientModel';
import { ProfileModel } from './ProfileModel';

export interface UserModel {
    id: number,
    metricUsername: string | null,
    username: string | null,
    codeMetric : number,
    email: string | null,
    password: string | null,
    updateDate: Date | null,
    profileId: number | null,
    profile: ProfileModel | null,
    isActive: boolean,
    recoveryCode?: string,
    userId: number,
    clients?: ClientModel[]
}

export const userModelInitial: UserModel = {
    id: 0,
    metricUsername: null,
    username: null,
    codeMetric: 0,
    email: null,
    password: null,
    updateDate: null,
    profileId: null,
    profile: null,
    isActive: false,
    userId: 0
};